import { Steps, Status } from '../model/sale.model'

import PATHS from '~/router/paths'

export function getSteps(isPostPaid: boolean): Steps {
  return {
    SALES: {
      id: 'sales',
      number: 0,
      path: PATHS.SALES,
      label: 'Configuración de venta',
      status: Status.EMPTY,
    },
    OFFER_SETUP: {
      id: 'offer-setup',
      number: 1,
      path: PATHS.OFFER_SETUP,
      label: 'Datos de línea y titular',
      status: Status.EMPTY,
    },
    ...((isPostPaid && {
      BILLING: {
        id: 'billing',
        number: 2,
        path: PATHS.BILLING,
        label: 'Facturación',
        status: Status.EMPTY,
      },
    }) ||
      {}),
    SUMMARY: {
      id: 'summary',
      number: isPostPaid ? 3 : 2,
      path: PATHS.SUMMARY,
      label: 'Resumen',
      status: Status.EMPTY,
    },
    CHECKOUT: {
      id: 'checkout',
      number: isPostPaid ? 4 : 3,
      path: PATHS.CHECKOUT,
      label: 'Finalizar Venta',
      status: Status.EMPTY,
    },
  }
}
export default getSteps
